module.exports = __webpack_public_path__ + "img/defaultProductIco.20259741.png";